import { render, staticRenderFns } from "./logisaddimport.vue?vue&type=template&id=260dfbe2"
import script from "./logisaddimport.vue?vue&type=script&lang=js"
export * from "./logisaddimport.vue?vue&type=script&lang=js"
import style0 from "./logisaddimport.vue?vue&type=style&index=0&id=260dfbe2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports